import { render, staticRenderFns } from "./OtherSolutionsTabComponent.vue?vue&type=template&id=4dcf6e78&scoped=true"
import script from "./OtherSolutionsTabComponent.vue?vue&type=script&lang=js"
export * from "./OtherSolutionsTabComponent.vue?vue&type=script&lang=js"
import style0 from "./OtherSolutionsTabComponent.vue?vue&type=style&index=0&id=4dcf6e78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcf6e78",
  null
  
)

export default component.exports